import React, { useState, useEffect } from 'react';
import '../../css/onboardingFirstSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useMobileMediaQuery, useTabletMediaQuery, useUltraMobileMediaQuery } from '../../utils';
import CustomButton from '../../components/CustomButton';
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { GTM } from '../../components/GTM/GTM';

function OnboardingStepTwo({ onNext, onSkip, mainImgSvg, onPrev }) {

    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isUltraMobile = useUltraMobileMediaQuery();

    useEffect(() => {
        const delay = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(delay);
    }, []);

    return (
        <>
            <GTM />
            <Header />
            {!isTablet &&
                <>
                    <div className='mainBgViewContainerStepsStackMobileTablet'></div>
                </>
            }
            <div className={isTablet ? 'mainViewContainerStepsStack' : (isMobile ? 'mainViewContainerStepsStackTablet' : 'mainViewContainerStepsStackMobile')}>
                {!isTablet &&
                    <>
                        <div className={isMobile ? 'mainImgViewStepsStackTablet' : 'mainImgViewStepsStackMobile'}>
                            <img src={mainImgSvg} alt="imagem" className={isMobile ? "mainImgStepsStackTablet" : (isUltraMobile ? "mainImgStepsStackPreMobile" : "mainImgStepsStackMobile")} />
                        </div>
                    </>
                }
                <div className={isTablet ? 'firstTxtViewContainerStepsStack' : (isMobile ? 'firstTxtViewContainerStepsStackTablet' : 'firstTxtViewContainerStepsStackMobile')}>
                    <div className='firstTitleViewStepsStack'>
                        <span className={isTablet ? 'textTitlePart1StepsStack' : (isMobile ? 'textTitlePart1StepsStackTablet' : 'textTitlePart1StepsStackMobile')}>Associe o seu </span>
                        <span className={isTablet ? 'textTitlePart2StepsStack' : (isMobile ? 'textTitlePart2StepsStackTablet' : 'textTitlePart2StepsStackMobile')}>cartão bancário</span>
                        <span className={isTablet ? 'textTitlePart3StepsStack' : (isMobile ? 'textTitlePart2StepsStackTablet' : 'textTitlePart2StepsStackMobile')}>.</span>
                    </div>
                    <div style={{ marginRight: 30 }} className={isTablet ? 'secondTitleViewStepsStack' : (isMobile ? 'secondTitleViewStepsStackTablet' : 'secondTitleViewStepsStackMobile')}>Use uma caixa MULTIBANCO ou a app MB WAY.</div>
                    <div style={{ marginRight: 35 }}>
                        <div className={isTablet ? 'secondSmallTitleViewStepsStack' : (isMobile ? 'secondSmallTitleViewStepsStackTablet' : 'secondSmallTitleViewStepsStackMobile')}>
                            <span className={isTablet ? 'secondSmallTitleViewStepsStack' : (isMobile ? 'secondSmallTitleViewStepsStackTablet' : 'secondSmallTitleViewStepsStackMobile')}>O primeiro passo é associar o cartão! Depois, é só ganhar saldo que pode </span>
                            <span className={isTablet ? 'secondSmallTitleViewStepsStack' : (isMobile ? 'secondSmallTitleViewStepsStackTablet' : 'secondSmallBoldTitleViewStepsStackMobile')}>gastar no Marketplace Médis</span>
                            <span className={isTablet ? 'secondSmallTitleViewStepsStack' : (isMobile ? 'secondSmallTitleViewStepsStackTablet' : 'secondSmallTitleViewStepsStackMobile')}> ou receber por transferência bancária.</span>
                        </div>
                    </div>

                    <div className={isTablet ? 'btnsViewStepsStack' : (isMobile ? 'btnsViewStepsStackTablet' : 'btnsViewStepsStackMobile')}>
                        <div className={isTablet ? 'divBtnSaltarStepsStack' : (isMobile ? 'divBtnSaltarStepsStackTablet' : 'divBtnSaltarStepsStackMobile')}>
                            <CustomButton
                                text={'Saltar'}
                                textColor={'#00214D'}
                                onPress={() => onSkip()}
                                hasSubLine
                                hasSubLineSmall
                                hasSubLineSmallColor={'#00214D'}
                                fontSize={'14px'}
                            />
                        </div>
                        <div className={isTablet ? 'divBtnNextStepsStack' : (isMobile ? 'divBtnSaltarStepsStackTablet' : 'divBtnNextStepsStackMobile')}>
                            <CustomButton
                                text={'Próximo'}
                                textColor={'#00214D'}
                                onPress={() => onNext()}
                                color={isTablet ? '#fff' : (isMobile ? '#fff' : '#fff')}
                                hasArrow
                                iconColor={'#00214D'}
                                hasShadowWithe
                            />
                        </div>
                    </div>
                    {
                        isTablet ? null : (isMobile ? (
                            <>
                                <div className='cirlceSelectedViewStepsStackMobile'>
                                    <div className='cirlceSelectedStepsStackMobile'>
                                        <div className='circleMainvViewStepsStack'>
                                            <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                                <FaArrowLeftLong className='iconArrowStepsStack' />
                                            </button>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleSelectedViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                                <FaArrowRightLong className='iconArrowStepsStack' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) :
                            <>
                                <div className='cirlceSelectedViewStepsStackMobile'>
                                    <div className='cirlceSelectedStepsStackMobile'>
                                        <div className='circleMainvViewStepsStack'>
                                            <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                                <FaArrowLeftLong className='iconArrowStepsStack' />
                                            </button>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleSelectedViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <div className='circleContainerStepsStack'>
                                                <div className='circleViewStepsStack' />
                                            </div>
                                            <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                                <FaArrowRightLong className='iconArrowStepsStack' />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }
                </div>
                {isTablet &&
                    <>
                        <div className='subFirstImgViewContainerStepsStack'>
                            <div className='firstImgViewContainerStepsStack'>
                                <div className='mainImgViewStepsStack'>
                                    <img src={mainImgSvg} alt="imagem" className="mainImgStepsStack" />
                                </div>
                                <div className='cirlceSelectedStepsStack'>
                                    <div className='circleMainvViewStepsStack'>
                                        <button className='iconArrowLeftViewStepsStack' onClick={() => onPrev()}>
                                            <FaArrowLeftLong className='iconArrowStepsStack' />
                                        </button>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleSelectedViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <div className='circleContainerStepsStack'>
                                            <div className='circleViewStepsStack' />
                                        </div>
                                        <button className='iconArrowRightViewStepsStack' onClick={() => onNext()}>
                                            <FaArrowRightLong className='iconArrowStepsStack' />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <Footer />
        </>
    )
}

export default OnboardingStepTwo;